/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { IUserSettings } from '../../../core/models';

@Component({
  selector: 'fm-ev-battery-range-section',
  templateUrl: './ev-battery-range-section.component.html',
  styleUrls: ['./ev-battery-range-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EvBatteryRangeSectionComponent {

  @Input()
  isTooltip: boolean;
  @Input()
  startTime: string;
  @Input()
  endTime: string;
  @Input()
  isChargingStart: boolean;
  @Input()
  isChargingEnd: boolean;
  @Input()
  startPercentage: number;
  @Input()
  endPercentage: number;
  @Input()
  userSettings: IUserSettings;
}
